import { Table } from "react-bootstrap"

const InventoryReport = ({ data }) => {
  return (
    <Table className='dashboard-inventory-report'>
      <thead>
        <tr>
          <th></th>
          <th>LRD</th>
          <th>CKV</th>
          <th>DTW</th>
        </tr>
      </thead>
      <tbody>
        {data.map((item, index) => (
          <tr className='inventory-report' key={index}>
            <td className='first-column'>{item.title}</td>
            <td
              className={
                typeof item.lrd === "number" &&
                item.lrd > 0 &&
                ([0, 1, 2, 4].includes(index))
                  ? "warning"
                  : ""
              }
            >
              {item.lrd}
            </td>
            <td
              className={
                typeof item.ckv === "number" &&
                item.ckv > 0 &&
                ([0, 1, 2, 4].includes(index))
                  ? "warning"
                  : ""
              }
            >
              {item.ckv}
            </td>
            <td
              className={
                typeof item.dtw === "number" &&
                item.dtw > 0 &&
                ([0, 1, 2, 4].includes(index))
                  ? "warning"
                  : ""
              }
            >
              {item.dtw}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default InventoryReport
